<template>
	<div class="container">
		<portal to="logo">
			<ul class="nav navbar-nav ml-2">
				<li class="nav-item d-flex justify-content-center my-auto">
					<a :href="`/${lastSite || ''}`">
						<img :src="`/images/site-option/${logo || 0}?width=180&height=72&fit=contain`" alt="logo" class="company-logo">
					</a>
				</li>
			</ul>
		</portal>

		<div class="row">
			<div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
				<div class="card card-signin my-5">
					<div class="card-body">
						<h5 class="card-title text-center">{{ $t("Login") }}</h5>
						<div class="form-signin">
							<a :href="`${oauthProxyDomain}/redirect/google/${companySubdomain}/${lastSite}`" class="btn btn-lg btn-google btn-block text-uppercase mb-3"><i class="fab fa-google mr-2" aria-hidden="true"></i> {{ $t("Sign in with Google") }}</a>
							<a :href="`${oauthProxyDomain}/redirect/facebook/${companySubdomain}/${lastSite}`" class="btn btn-lg btn-facebook btn-block text-uppercase mb-3"> <i class="fab fa-facebook-f mr-2" aria-hidden="true"> </i> {{ $t("Sign in with Facebook") }}</a>
							<a :href="`${oauthProxyDomain}/redirect/apple/${companySubdomain}/${lastSite}`" class="btn btn-lg btn-apple btn-block text-uppercase"> <i class="fab fa-apple mr-2" aria-hidden="true"> </i> {{ $t("Sign In With Apple") }}</a>
							<hr class="my-5">
						</div>
						<div class="privacy">
							<ul>
								<li><a href="/pages/privacy-policy">{{ $t("Privacy") }}</a></li>
								<li><span class="vl"></span></li>
								<li><a href="/pages/terms-and-conditions">{{ $t("Terms & Conditions") }}</a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			oauthProxyDomain: window.app.oauth_proxy_domain,
			companySubdomain: window.app.company_subdomain,
			lastSite: window.app.last_site,
			logo: window.app.site_logo
		}
	},
	mounted() {
		this.$pageTitle = this.$t("Login");
	}
}
</script>
